import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { useIntl} from "gatsby-plugin-intl"

import MarkdownRenderer from "../components/MarkdownRenderer";
import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = () => {
	
	const intl = useIntl();
	
	//console.log(intl);

	return (
		<Layout>
			<div className="row">
				<div className="col-3 d-none d-lg-block">
					<StaticImage src="../images/robot1.png" alt="PO TRADE BOT" width={256} />
				</div>
				<div className="col mt-4">
					<h5>{intl.formatMessage({ id: "mainCaption1" })}</h5>
					<MarkdownRenderer>{intl.formatMessage({ id: "mainText1" })}</MarkdownRenderer>
					<a className="btn btn-warning me-2" href="https://2bot.top/reg/" role="button">{intl.formatMessage({ id: "Registration" })}</a>
					<a className="btn btn-success" href="https://2bot.top/download/" role="button">{intl.formatMessage({ id: "Download" })}</a>
				</div>			
			</div>
			
			<div className="row mb-2">
				<div className="col">
					<h5>{intl.formatMessage({ id: "mainCaption2" })}</h5>
					<MarkdownRenderer>{intl.formatMessage({ id: "mainText2" })}</MarkdownRenderer>
				</div>					
			
				<div className="col-12 col-lg-6">
					<iframe width="100%" height="315" src="https://www.youtube.com/embed/NqVJSgFbf9g" title="PocketOption BOT" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen=""></iframe>
				</div>
			</div>
			
			<div className="row">
				<div className="col mb-2">	
					<ol className="list-group list-group-numbered p-2 bg-success-subtle">

						{[1,2,3,4,5,6,7].map(item=>(
							<li className="list-group-item d-flex justify-content-between align-items-start" key={"table_li_"+item}>
								<div className="ms-2 me-auto">
									<div className="fw-bold">{intl.formatMessage({ id: "mainListCaption"+item })}</div>
									<div>{intl.formatMessage({ id: "mainListText"+item })}</div>
								</div>
							</li>
						))}							

					</ol>
				</div>			
			</div>	
			
			<div className="row my-2">
				<div className="col">
					<MarkdownRenderer>{intl.formatMessage({ id: "mainText3" })}</MarkdownRenderer>
				</div>
			</div>
				
		</Layout>
	)
}

/**
 * Head export to define metadata for the page
 *
 * See: https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-head/
 */
export const Head = () => <Seo title="Home" />

export default IndexPage
